<p-table
  #table
  [columns]="columns"
  [value]="data"
  [sortField]="'CreatedDate'"
  [sortOrder]="2"
  [lazy]="!clientSidePagination()"
  [showCurrentPageReport]="false"
  [paginator]="withPaginator() && data.length > 0"
  [rowsPerPageOptions]="[5, 10, 15, 20]"
  [rows]="bodyOptions?.pageSize || data.length"
  [pageLinks]="3"
  [totalRecords]="totalCount"
  [autoLayout]="true"
  [customSort]="true"
  (onLazyLoad)="clientSidePagination() ? null : loadLazyLoadedData($event)"
  styleClass="p-datatable-generic"
  (window:resize)="initializeInputs()"
>
  <ng-template pTemplate="header" let-columns>
    <!-- Table Headers-->
    <tr class="table-header">
      @for (column of columns; track $index) {
        <th [pSortableColumnDisabled]="true" [pSortableColumn]="column.field" scope="col" [style.min-width]="column?.width ?? 'auto'">
          {{ column.header | translate }}

          @if (column.filter) {
            <p-sortIcon class="cursor-pointer" [field]="column.field" />
          }
        </th>
      }

      <!-- Show Action In Header Row-->
      @if (actions && actions.length) {
        <th class="actions" [style.width]="((actions.length || 0) * 2.2).toFixed(1) + 'rem'" scope="col" style="width: auto">
          {{ "ACTIONS.TITLE" | translate }}
        </th>
      }
    </tr>

    <!-- Filter Controls-->
    @if (isFilterEnabled) {
      <tr class="table-search-controls">
        @for (column of columns; track $index) {
          <th class="control" scope="col" [style.min-width]="column?.width ?? 'auto'">
            <ng-container [formGroup]="filterForm">
              @switch (column.filter) {
                @case (true) {
                  @if (column.filterMode === "text") {
                    <app-input-text
                      class="table-filter w-100"
                      appearance="fill"
                      [contentType]="column.filterContent"
                      [label]="column.header | translate"
                      [formControlName]="column.filterColumnName?.split(',')[0] || column.field"
                      (inputValue)="
                        clientSidePagination()
                          ? table.filter($event, column.field, column.matchMode || 'contains')
                          : filter($event, column.field, column.filterColumnName, column.filterContent)
                      "
                    />
                  }

                  @if (column.filterMode === "date") {
                    <app-datepicker
                      class="table-filter w-100"
                      appearance="fill"
                      [label]="column.header | translate"
                      [formControlName]="column.filterColumnName?.split(',')[0] || column.field"
                      (onDateChange)="
                        clientSidePagination()
                          ? table.filter($event, column.field, column.matchMode || 'contains')
                          : filter($event, column.field, column.filterColumnName, column.filterContent)
                      "
                    />
                  }
                }
              }
            </ng-container>
          </th>
        }

        @if (actions && actions.length) {
          <th class="actions" scope="col"></th>
        }
      </tr>
    }
  </ng-template>

  <ng-template pTemplate="body" let-row let-columns="columns">
    <!-- Table Rows-->
    <tr class="table-body" [class.d-none]="data && !data.length">
      <!-- Display Data-->
      @for (column of columns; track $index) {
        <td [style.min-width]="column?.width ?? 'auto'">
          @if (column.customCellFormatter && !["image"].includes(column.dataType)) {
            <span class="font-13 {{ column.customCellClass && column.customCellClass(row) }}">
              {{ column.customCellFormatter(row) }}
            </span>
          } @else {
            @switch (column.dataType) {
              @case ("date") {
                <span class="font-13">
                  @if (getCellData(row, column.field) !== "-") {
                    {{ getCellData(row, column.field) | date: (column.dateFormat ? column.dateFormat : "dd/MM/yyyy") }}
                  } @else {
                    {{ "-" }}
                  }
                </span>
              }

              @case ("image") {
                @if (column.field) {
                  <span class="font-13 p-1">
                    @if ((column.customCellFormatter && column.customCellFormatter(row)) || getCellData(row, column.field) !== "-") {
                      <img
                        [src]="column.customCellFormatter(row) ?? getCellData(row, column.field)"
                        [alt]="column.field + ' Image'"
                        width="50"
                        height="50"
                        style="border-radius: 25px"
                        onerror="this.src = 'assets/images/empty/no_data.svg'"
                        (click)="onView(getCellData(row, column.field), column.header)"
                      />
                    } @else {
                      {{ "-" }}
                    }
                  </span>
                } @else {
                  {{ "-" }}
                }
              }

              <!-- text -->
              @default {
                <span
                  class="font-13 {{ column.customCellClass && column.customCellClass(row) }}"
                  [title]="getCellData(row, column.field) || ''"
                >
                  @if (getCellData(row, column.field)) {
                    {{ getCellData(row, column.field) }}
                  } @else {
                    -
                  }
                </span>
              }
            }
          }
        </td>
      }

      @if (actions && actions.length) {
        <td class="actions" [style.width]="((actions.length || 0) * 1.5).toFixed(0) + 'rem'">
          <span class="d-flex align-items-center gap-2 font-14">
            @for (action of actions; track $index) {
              @if (action.icon) {
                <!-- && permissions.indexOf('Permission.'+ componentName+ '.Edit') > -1 -->
                @if ((action.isEdit || action.isView) && (!action.displayBasedOn || action.displayBasedOn(row))) {
                  <span>
                    <a [routerLink]="getFinalRoute(action.route, row.id)">
                      <em class="{{ action.icon }} icon {{ action.color }}" [title]="'ACTIONS.' + action.name | translate"></em>
                    </a>
                  </span>
                }

                <!-- && permissions.indexOf('Permission.'+ componentName + '.Delete') > -1 -->
                @if (action.isDelete && (!action.displayBasedOn || action.displayBasedOn(row))) {
                  <span>
                    <em
                      class="{{ action.icon }} icon {{ action.color }}"
                      (click)="openDeleteModal(row, action.call)"
                      [title]="'ACTIONS.' + action.name | translate"
                    ></em>
                  </span>
                }

                @if (!action.isEdit && !action.isView && !action.isDelete && (!action.displayBasedOn || action.displayBasedOn(row))) {
                  <span>
                    <em
                      class="{{ action.icon }} icon {{ action.color }}"
                      (click)="action?.call(row)"
                      [title]="'ACTIONS.' + action.name | translate"
                    ></em>
                  </span>
                }

                @if (
                  action.isCheckBox &&
                  !action.isEdit &&
                  !action.isView &&
                  !action.isDelete &&
                  (!action.displayBasedOn || action.displayBasedOn(row))
                ) {
                  <mat-checkbox (change)="action?.call(row)" color="primary" />
                }
              } @else if (!action.icon && action.call && (!action.displayBasedOn || action.displayBasedOn(row))) {
                <app-button [btnLabel]="action.name" [btnClass]="action.color" (onClick)="action.call(row)" />
              }
            }
          </span>
        </td>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    @if (sortOrder === 0 || sortOrder === 1 || sortOrder === -1) {
      <em class="db-icon-filter font-16 text-white"></em>
    }
  </ng-template>
</p-table>

@if (data && !data.length) {
  <div class="d-flex align-items-center justify-content-center h-100">
    <p class="m-0">{{ "EMPTY.NO_DATA" | translate }}</p>
  </div>
}
